import { useCallback, useRef, useState } from 'react';
import type { BillingInfoData } from '@shipstation/financial-services-ui-components';

import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import { messages as rootMessages } from '../messages';

import { PaymentMethodSection } from './payment-method-section';
import { WwexSubViewFooter } from './wwex-sub-view-footer';
import { WwexSubViewHeader } from './wwex-sub-view-header';
import modalStyle from '../wwex-registration-modal.module.less';

type AddPaymentMethodViewProps = {
  headerId: string;
  isDisabled: boolean;
  onPaymentMethodCreated: (paymentMethodId: string, billingInfo?: BillingInfoData) => void;
  onBack: () => void;
  onCancel: () => void;
};

export const AddPaymentMethodView = ({ headerId, isDisabled, onPaymentMethodCreated, onBack, onCancel }: AddPaymentMethodViewProps) => {
  const submitPaymentRef = useRef<(() => void) | null>(null);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const isViewDisabled = isDisabled || isProcessingPayment;

  const handleSubmitFunctionReady = useCallback((fn: (() => void) | null) => {
    submitPaymentRef.current = fn;
  }, []);

  const handleSave = useCallback(() => {
    submitPaymentRef.current?.();
  }, []);

  return (
    <>
      <ModalHeader className={modalStyle.modalHeader} closeModal={onCancel} id={headerId}>
        <WwexSubViewHeader isDisabled={isViewDisabled} onBack={onBack} titleMessage={rootMessages.addPaymentMethodTitle} />
      </ModalHeader>

      <ModalBody className={modalStyle.modalBody}>
        <PaymentMethodSection
          onPaymentMethodCreated={onPaymentMethodCreated}
          onProcessingChange={setIsProcessingPayment}
          onSubmitFunctionReady={handleSubmitFunctionReady}
        />
      </ModalBody>

      <ModalFooter>
        <WwexSubViewFooter isDisabled={isViewDisabled} onBack={onBack} onCancel={onCancel} onSave={handleSave} />
      </ModalFooter>
    </>
  );
};
